module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Section Section-Cart-Items"
  }, [_vm._l((_vm.cart), function(cart_item) {
    return [_c('item-row', {
      attrs: {
        "cart_item": cart_item,
        "can_remove": _vm.can_remove,
        "currency": _vm.active_module.currency
      }
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2fedad46!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cart/Cart.vue
// module id = 249
// module chunks = 1